import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "collapsedIcon", "expandedIcon", "chevron", "toggle"];
  static values = { open: Boolean };

  connect() {
    // Set initial state based on data attribute
    this.isOpen = this.openValue;
    this.updateDisplay();
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.updateDisplay();
  }

  updateDisplay() {
    const content = this.contentTarget;

    if (this.isOpen) {
      // Show content
      content.style.maxHeight = content.scrollHeight + "px";
      content.style.opacity = "1";
      content.setAttribute("data-state", "open");

      // Handle icon targets (if present)
      if (this.hasCollapsedIconTarget && this.hasExpandedIconTarget) {
        this.collapsedIconTarget.style.opacity = "0";
        this.expandedIconTarget.style.opacity = "1";
      }

      // Handle chevron rotation (if present)
      if (this.hasChevronTarget) {
        this.chevronTarget.classList.add("rotate-180");
      }

      // Reflect state on the toggle control itself (if present) for
      // assistive tech — the context rail's mobile rows (TASK-224.4).
      if (this.hasToggleTarget) {
        this.toggleTarget.setAttribute("aria-expanded", "true");
      }

      // Update container state
      this.element.setAttribute("data-state", "open");
    } else {
      // Hide content
      content.style.maxHeight = "0";
      content.style.opacity = "0";
      content.setAttribute("data-state", "closed");

      // Handle icon targets (if present)
      if (this.hasCollapsedIconTarget && this.hasExpandedIconTarget) {
        this.collapsedIconTarget.style.opacity = "1";
        this.expandedIconTarget.style.opacity = "0";
      }

      // Handle chevron rotation (if present)
      if (this.hasChevronTarget) {
        this.chevronTarget.classList.remove("rotate-180");
      }

      if (this.hasToggleTarget) {
        this.toggleTarget.setAttribute("aria-expanded", "false");
      }

      // Update container state
      this.element.setAttribute("data-state", "closed");
    }
  }
}

